import clsx from 'clsx';

import Image from '../Image';

import styles from './Icons.module.css';
import { WarningIconProps } from './types';

const WarningIcon = ({ width, height, className, disabled }: WarningIconProps) => (
  <Image
    src={'/marketplace-static/images/icons/warningIcon.svg'}
    width={width || 18}
    height={height || 18}
    alt="warning icon"
    layout="fixed"
    className={clsx(styles.warningIcon, 'warningIcon', { warningIconDisabled: disabled }, className)}
  />
);

export default WarningIcon;
